/**
 *

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type CanProvideDailyExerciseEnum = boolean;

export const CanProvideDailyExerciseEnum = { true: true, false: false } as const;
